import { v7 as uuid } from 'uuid';

export class ResourceKit {
    id = uuid();

    tenantId = 0;

    name = '';

    description = '';

    isActive = true;

    resources = [];
}
